export default "__VITE_ASSET__BbHpPXOj__"